<template>
  <div class="container">
    <DesktopSteps
      :steps="steps"
      :last="lastStep"
      :selected="stepSelected"
      :disabled="stepsDisabled"
      :onSelect="onSelectStep"
    />
    <DocumentGenerationProgress
      :generation="step4.generation"
      :connectionError="step4.connectionError"
    />
    <div v-if="step4.uploading" class="operation-progress" role="status" aria-live="polite">
      <p>Subiendo adjuntos adicionales: {{ step4.uploadedAttachments }} de {{ step4.attachmentTotal }}.</p>
      <ProgressBar mode="indeterminate" aria-label="Subiendo adjuntos adicionales" />
      <p>Mantené esta pantalla abierta hasta que terminen de subir los adjuntos.</p>
    </div>
    <p v-if="step4.error" class="operation-error" role="alert">{{ step4.error }}</p>
    <p v-if="step5.sendUncertain" class="operation-error" role="alert">
      No se pudo confirmar el resultado del envío. Actualizá el estado del cierre antes de volver a enviar para evitar duplicados.
    </p>
    <PrimaryButton
      v-if="step4.connectionError || step5.sendUncertain"
      label="Actualizar estado"
      :click="refreshStatus"
    />
    <input id="upload-detail" class="upload" type="file" />
    <input id="upload-movement" class="upload" type="file" />
    <!-- Introduccion -->
    <div v-if="stepSelected === 1" class="container-form">
      <BasicTitle title="Introducción" />
      <BasicSubtitle
        subtitle="Los campos señalados con (*) son obligatorios."
      />
      <FormError />
      <BasicLabel label="Mes *" />
      <BorderSelect
        v-model="step1.data.month"
        label="Mes *"
        :options="step1.months"
        :disabled="hidden"
      />
      <FormError :show="step1.rules.month" message="Seleccione el mes" />
      <BasicLabel label="Año *" />
      <BorderSelect
        v-model="step1.data.year"
        label="Año *"
        :options="step1.years"
        :disabled="hidden"
      />
      <FormError :show="step1.rules.year" message="Seleccione el año" />
      <BasicLabel label="Saldo Inicial del Mes *" />
      <BorderInput
        v-model="step1.data.actualBalance"
        label="Saldo Inicial del Mes *"
        type="number"
        :disabled="hidden"
      />
      <FormError
        :show="step1.rules.actualBalance"
        message="Ingrese el saldo inicial del mes"
      />
      <BasicLabel label="Fecha de Vencimiento de pago *" />
      <BorderDate
        v-model="step1.data.expirationDate"
        label="Fecha de Vencimiento de pago *"
        :disabled="hidden"
      />
      <FormError
        :show="step1.rules.expirationDate"
        message="Seleccione una fecha"
      />
      <BasicLabel label="Comentarios" />
      <OutlinedTextArea v-model="step1.data.comment" :disabled="hidden" />
      <FormError />
      <PrimaryButton v-if="!hidden" label="Siguiente" :click="onNext" />
    </div>

    <!-- Cierre Detalle de Gastos Comunes -->
    <div v-if="stepSelected === 2" class="container-form">
      <BasicTitle title="Cierre Detalle de Gastos Comunes" />
      <FormError />
      <div>
        <Actions v-if="!hidden" :items="step2.actions" :right="true" />
        <MobileTable
          label="Detalle de gastos comunes por mes"
          :columns="step2.columns"
          :data="step2.list"
          v-model:selection="step2.selected"
          :rows="50"
        />
        <DesktopTable
          label="Detalle de gastos comunes por mes"
          :columns="step2.columns"
          :data="step2.list"
          v-model:selection="step2.selected"
          :rows="50"
        />
      </div>
      <FormError />
      <PrimaryButton v-if="!hidden" label="Siguiente" :click="onNext" />
      <BasicModal v-model:visible="step2.showDialog">
        <template v-slot:dialog>
          <BasicTitle title="Modificar detalle de gastos comunes" />
          <BasicSubtitle
            subtitle="Los campos señalados con (*) son obligatorios."
          />
          <div class="container-form">
            <BasicLabel label="No. Torre *" />
            <BorderInput v-model="step2.data.tower" label="No. Torre *" />
            <FormError :show="step2.rules.tower" />
            <BasicLabel label="No. Apartamento *" />
            <BorderInput
              v-model="step2.data.apartment"
              label="No. Apartamento *"
            />
            <FormError :show="step2.rules.apartment" />
            <BasicLabel label="Propietario o Inquilino (P o I) *" />
            <BorderSelect
              v-model="step2.data.owner"
              label="Propietario o Inquilino (P o I) *"
              :options="step2.owners"
            />
            <FormError :show="step2.rules.owner" />
            <BasicLabel label="Saldo mes anterior *" />
            <BorderInput
              v-model="step2.data.prevBalance"
              label="Saldo mes anterior *"
              type="number"
            />
            <FormError :show="step2.rules.prevBalance" />
            <BasicLabel label="Pagos *" />
            <BorderInput
              v-model="step2.data.payments"
              label="Pagos *"
              type="number"
            />
            <FormError :show="step2.rules.payments" />
            <BasicLabel label="Saldo mes actual *" />
            <BorderInput
              v-model="step2.data.balance"
              label="Saldo mes actual *"
              type="number"
              :disabled="true"
            />
            <FormError :show="step2.rules.balance" />
            <BasicLabel label="Recargo o deuda *" />
            <BorderInput
              v-model="step2.data.surcharge"
              label="Recargo o deuda *"
              type="number"
            />
            <FormError :show="step2.rules.surcharge" />
            <BasicLabel label="Gastos comunes *" />
            <BorderInput
              v-model="step2.data.commonExpenses"
              label="Gastos comunes *"
              type="number"
            />
            <FormError :show="step2.rules.commonExpenses" />
            <BasicLabel label="Cuota extra *" />
            <BorderInput
              v-model="step2.data.extraFee"
              label="Cuota extra *"
              type="number"
            />
            <FormError :show="step2.rules.extraFee" />
            <BasicLabel label="Fondo de reserva *" />
            <BorderInput
              v-model="step2.data.reserveFound"
              label="Fondo de reserva *"
              type="number"
            />
            <FormError :show="step2.rules.reserveFound" />
            <BasicLabel label="Áreas comunes *" />
            <BorderInput
              v-model="step2.data.commonAreas"
              label="Áreas comunes *"
              type="number"
            />
            <FormError :show="step2.rules.commonAreas" />
            <BasicLabel label="Total a pagar del mes *" />
            <BorderInput
              v-model="step2.data.totalPeriod"
              label="Total a pagar del mes *"
              type="number"
              :disabled="true"
            />
            <FormError :show="step2.rules.totalPeriod" />
            <BasicLabel label="Total a pagar del mes *" />
            <BorderInput
              v-model="step2.data.totalDebt"
              label="Total a pagar del mes *"
              type="number"
              :disabled="true"
            />
            <FormError :show="step2.rules.totalDebt" />
            <PrimaryButton
              :disabled="!step2.list.length"
              label="Guardar"
              :click="step2.onSave"
            />
          </div>
        </template>
      </BasicModal>
    </div>

    <!-- Cierre Detalle de Gastos del Complejo -->
    <div v-if="stepSelected === 3" class="container-form">
      <BasicTitle title="Cierre Detalle de Gastos del Complejo" />
      <FormError />
      <div>
        <div class="step3-container">
          <BasicSubtitle
            :error="step3.negative1"
            :title="`Saldo Inicial: ${getActualBalance(null)}`"
          />
          <BasicSubtitle
            :error="step3.negative"
            :title="`Saldo Final: ${getActualBalance(step3.list)}`"
          />
        </div>
        <Actions v-if="!hidden" :items="step3.actions" :right="true" />
        <MobileTable
          label="Detalle de gastos comunes por mes"
          :columns="step3.columns"
          :data="step3.list"
          :rows="50"
          v-model:selection="step3.selected"
        />
        <DesktopTable
          label="Detalle de gastos comunes por mes"
          :columns="step3.columns"
          :data="step3.list"
          :rows="50"
          v-model:selection="step3.selected"
        />
      </div>
      <FormError />
      <PrimaryButton v-if="!hidden" label="Siguiente" :click="onNext" />
      <BasicModal v-model:visible="step3.showDialog">
        <template v-slot:dialog>
          <BasicTitle title="Modificar movimiento" />
          <BasicSubtitle
            subtitle="Los campos señalados con (*) son obligatorios."
          />
          <div class="container-form">
            <BasicLabel label="Rubro *" />
            <BorderInput v-model="step3.data.heading" label="Rubro *" />
            <FormError :show="step3.rules.heading" />
            <BasicLabel label="Detalle *" />
            <BorderInput v-model="step3.data.detail" label="Detalle *" />
            <FormError :show="step3.rules.detail" />
            <BasicLabel label="Fecha *" />
            <BorderDate v-model="step3.data.date" label="Fecha *" />
            <FormError />
            <BasicLabel label="Ingreso *" />
            <BorderInput
              v-model="step3.data.income"
              label="Ingreso *"
              type="number"
            />
            <FormError :show="step3.rules.income" />
            <BasicLabel label="Egreso *" />
            <BorderInput
              v-model="step3.data.expense"
              label="Egreso *"
              type="number"
            />
            <FormError :show="step3.rules.expense" />
            <BasicLabel label="Total *" />
            <BorderInput
              v-model="step3.data.total"
              label="Total *"
              type="number"
              :disabled="true"
            />
            <FormError :show="step3.rules.total" />
            <PrimaryButton
              :disabled="!step3.list.length"
              label="Guardar"
              :click="step3.onSave"
            />
          </div>
        </template>
      </BasicModal>
    </div>

    <!-- Generación de documentos -->
    <div v-if="stepSelected === 4" class="container-form">
      <BasicTitle title="Generación de documentos" />
      <!-- <BasicSubtitle
        subtitle="Los campos señalados con (*) son obligatorios."
      /> -->
      <DefaultCheck :list="step4.documentsList" />
      <BorderFile
        :disabled="generationBusy"
        @select="onSelectFiles"
        @remove="onSelectFiles"
        @clear="onClearFiles"
      />
      <p v-if="step4.selectedDocuments.length" class="operation-note">
        Los adjuntos se subirán después de los PDF. Mantené esta pantalla abierta hasta que termine la carga.
      </p>
      <p v-if="step4.missingAttachments" class="operation-error" role="alert">
        Quedaron adjuntos pendientes: {{ step4.pendingAttachmentNames.join(', ') }}.
        Volvé a seleccionarlos antes de enviar los correos.
      </p>
      <FormError />
      <PrimaryButton
        v-if="!hidden"
        :label="generateButtonLabel"
        :click="onNext"
        :disabled="generationBusy || step5.sending || step4.missingAttachments"
      />
    </div>

    <!-- Envío de Documentos al Residente -->
    <div v-if="stepSelected === 5" class="container-form">
      <BasicTitle title="Envío de Documentos al Residente" />
      <!-- <BasicSubtitle
        subtitle="Los campos señalados con (*) son obligatorios."
      /> -->
      <FormError />
      <div v-if="step5.sending" class="operation-progress" role="status" aria-live="polite">
        <p>Enviando correos…</p>
        <ProgressBar mode="indeterminate" aria-label="Enviando correos" />
        <p>Esperá la confirmación antes de volver a enviar.</p>
      </div>
      <PrimaryButton
        v-if="!hidden"
        label="Enviar"
        :click="onSend"
        :disabled="!step5.sendEnabled || generationBusy || step5.sending"
      />
    </div>
  </div>
</template>

<script>
import BasicModal from "../../widgets/modal/BasicModal";
import readXlsxFile from "read-excel-file";
import BasicTitle from "../../widgets/title/BasicTitle";
import BasicSubtitle from "../../widgets/subtitle/BasicSubtitle";
import BorderInput from "../../widgets/input/BorderInput";
import BorderSelect from "../../widgets/select/BorderSelect";
import BorderInputPrefix from "../../widgets/input/BorderInputPrefix";
import BorderInputPhone from "../../widgets/input/BorderInputPhone";
import FormError from "../../widgets/error/FormError";
import PrimaryButton from "../../widgets/button/PrimaryButton";
import DesktopSteps from "../../widgets/steps/DesktopSteps";
import BorderDate from "../../widgets/calendar/BorderDate";
import OutlinedTextArea from "../../widgets/textarea/OutlinedTextArea";
import BasicLabel from "../../widgets/label/BasicLabel";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import store from "../../store";
import ProgressBar from "primevue/progressbar";
import DocumentGenerationProgress from "../../components/shared/DocumentGenerationProgress.vue";
import { createClosurePoller } from "../../utils/closureProgress";
import {
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  computed,
  watch,
  watchEffect,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  openMode,
  actions,
  dates,
  currency,
  aws,
  validation,
} from "../../constants";
import DefaultCheck from "../../widgets/check/DefaultCheck.vue";

import BorderFile from "../../widgets/file/BorderFile.vue";

export default {
  components: {
    BasicTitle,
    BasicSubtitle,
    BorderInput,
    BorderSelect,
    BorderInputPrefix,
    BorderInputPhone,
    FormError,
    PrimaryButton,
    DesktopSteps,
    BorderDate,
    OutlinedTextArea,
    BasicLabel,
    Actions,
    DesktopTable,
    MobileTable,
    DefaultCheck,
    BasicModal,
    BorderFile,
    ProgressBar,
    DocumentGenerationProgress,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const hidden = ref(false);
    const closureBuildingId = ref(Number(route.query.edificio) || store.state.general.selectedBuilding);
    const closureStatusId = ref(0);
    let mounted = true;
    let closureInitialized = false;

    const lastStep = ref(1);
    const stepSelected = ref(1);
    const stepsDisabled = ref([]);
    const steps = [
      { id: 1, title: "Introducción" },
      { id: 2, title: "Cierre Detalle de Gastos Comunes" },
      { id: 3, title: "Cierre Detalle de Gastos del Complejo" },
      { id: 4, title: "Generación de documentos" },
      { id: 5, title: "Envío de Documentos al Residente" },
    ];
    const onSelectStep = async (step) => {
      if (generationBusy.value || step5.sending) return;
      stepSelected.value = step.id;
      if (step.id === 2) {
        store.commit("setLoading", true);
        const detail = await store.dispatch(
          actions.commonExpenseActions.findAllDetail,
          step1.data.id
        );
        store.commit("setLoading", false);
        if (detail.ok) {
          step2.list = detail.commonExpensesDetail;
        } else {
          alert(detail.message);
        }
      } else if (step.id === 3) {
        store.commit("setLoading", true);
        const movement = await store.dispatch(
          actions.commonExpenseActions.findAllMovement,
          step1.data.id
        );
        store.commit("setLoading", false);
        if (movement.ok) {
          step3.list = movement.movements;
        } else {
          alert(movement.message);
        }
      }
    };

    const today = new Date();

    const getYears = () => {
      const year = new Date().getFullYear();
      const years = [];
      for (let i = year - 5; i <= year + 5; i++) years.push({ id: i, name: i });
      return years;
    };

    const getMonths = () =>
      dates.months.map((month, idx) => ({ id: idx, name: month }));

    const step1 = reactive({
      months: getMonths(),
      years: getYears(),
      data: {
        id: -1,
        actualBalance: "",
        month: today.getMonth(),
        year: today.getFullYear(),
        expirationDate: "",
        comment: "",
      },
      rules: {
        actualBalance: false,
        expirationDate: false,
      },
    });

    const validateStep1 = () => {
      let isValid = true;
      if (!step1.data.actualBalance) {
        step1.rules.actualBalance = true;
        isValid = false;
      }
      if (!step1.data.expirationDate) {
        step1.rules.expirationDate = true;
        isValid = false;
      }

      return isValid;
    };

    const validateStep2 = (flag) => {
      let isValid = true;

      if (!flag) {
        if (!step2.data.tower) {
          step2.rules.tower = true;
          isValid = false;
        }
        if (!step2.data.apartment) {
          step2.rules.apartment = true;
          isValid = false;
        }
        if (!step2.data.owner) {
          step2.rules.owner = true;
          isValid = false;
        }
        if (!step2.data.prevBalance && step2.data.prevBalance != 0) {
          step2.rules.prevBalance = true;
          isValid = false;
        }
        if (!step2.data.payments && step2.data.payments != 0) {
          step2.rules.payments = true;
          isValid = false;
        }
        if (!step2.data.balance && step2.data.balance != 0) {
          step2.rules.balance = true;
          isValid = false;
        }
        if (!step2.data.surcharge && step2.data.surcharge != 0) {
          step2.rules.surcharge = true;
          isValid = false;
        }
        if (!step2.data.commonExpenses && step2.data.commonExpenses != 0) {
          step2.rules.commonExpenses = true;
          isValid = false;
        }
        if (!step2.data.extraFee && step2.data.extraFee != 0) {
          step2.rules.extraFee = true;
          isValid = false;
        }
        if (!step2.data.reserveFound && step2.data.reserveFound != 0) {
          step2.rules.reserveFound = true;
          isValid = false;
        }
        if (!step2.data.commonAreas && step2.data.commonAreas != 0) {
          step2.rules.commonAreas = true;
          isValid = false;
        }
        if (!step2.data.totalPeriod && step2.data.totalPeriod != 0) {
          step2.rules.totalPeriod = true;
          isValid = false;
        }
        if (!step2.data.totalDebt && step2.data.totalDebt != 0) {
          step2.rules.totalDebt = true;
          isValid = false;
        }
      } else if (!step2.list.length) {
        isValid = false;
      } else {
        /* const finded = step2.list.find(
          (item) =>
            currency.convertCurrencyToNumber(item.prevBalance) -
              currency.convertCurrencyToNumber(item.payments) !==
              currency.convertCurrencyToNumber(item.balance) ||
            currency.convertCurrencyToNumber(item.balance) +
              currency.convertCurrencyToNumber(item.surcharge) +
              currency.convertCurrencyToNumber(item.commonExpenses) +
              currency.convertCurrencyToNumber(item.extraFee) +
              currency.convertCurrencyToNumber(item.reserveFound) +
              currency.convertCurrencyToNumber(item.commonAreas) !==
              currency.convertCurrencyToNumber(item.totalDebt) ||
            currency.convertCurrencyToNumber(item.totalPeriod) !==
              currency.convertCurrencyToNumber(item.commonExpenses) +
                currency.convertCurrencyToNumber(item.extraFee) +
                currency.convertCurrencyToNumber(item.reserveFound) +
                currency.convertCurrencyToNumber(item.commonAreas)
        );
        if (finded) isValid = false; */
      }

      return isValid;
    };

    const validateStep3 = (flag) => {
      let isValid = true;
      if (!flag) {
        if (!step3.data.heading) {
          step3.rules.heading = true;
          isValid = false;
        }
        if (!step3.data.date) {
          step3.rules.date = true;
          isValid = false;
        }
        if (!step3.data.income && step3.data.income != 0) {
          step3.rules.income = true;
          isValid = false;
        }
        if (!step3.data.expense && step3.data.expense != 0) {
          step3.rules.expense = true;
          isValid = false;
        }
        if (!step3.data.total && step3.data.total != 0) {
          step3.rules.total = true;
          isValid = false;
        }
      } else if (!step3.list.length) {
        isValid = false;
      } else {
        /* const finded = step3.list.find(
          (item) =>
            currency.convertCurrencyToNumber(item.income) -
              currency.convertCurrencyToNumber(item.expense) !==
            currency.convertCurrencyToNumber(item.total)
        );
        if (finded) isValid = false; */
      }

      return isValid;
    };

    const step2OnSave = () => {
      if (!validateStep2(false)) return;

      step2.selected = [];
      step2.list = step2.list.map((item) =>
        item.id === step2.data.id
          ? {
              id: "",
              tower: step2.data.tower,
              owner: step2.data.owner,
              apartment: step2.data.apartment,
              prevBalance: +step2.data.prevBalance,
              payments: +step2.data.payments,
              balance: +step2.data.balance,
              surcharge: +step2.data.surcharge,
              commonExpenses: +step2.data.commonExpenses,
              extraFee: +step2.data.extraFee,
              reserveFound: +step2.data.reserveFound,
              commonAreas: +step2.data.commonAreas,
              totalPeriod: +step2.data.totalPeriod,
              totalDebt: +step2.data.totalDebt,
            }
          : item
      );
      step2.data = {
        id: "",
        owner: "",
        tower: "",
        apartment: "",
        prevBalance: "",
        payments: "",
        balance: "",
        surcharge: "",
        commonExpenses: "",
        extraFee: "",
        reserveFound: "",
        commonAreas: "",
        totalPeriod: "",
        totalDebt: "",
      };
      step2.showDialog = false;
    };

    const step3OnSave = () => {
      if (!validateStep3(false)) return;

      step3.selected = [];
      step3.list = step3.list.map((item) =>
        item.id === step3.data.id
          ? {
              commonExpenseId: item.commonExpenseId,
              id: item.id,
              date: step3.data.date,
              detail: step3.data.detail,
              heading: step3.data.heading,
              income: +step3.data.income,
              expense: +step3.data.expense,
              total: +step3.data.total,
            }
          : item
      );
      step3.data = {
        id: "",
        heading: "",
        detail: "",
        date: "",
        income: "",
        expense: "",
        total: "",
      };
      step3.showDialog = false;
    };

    const step2 = reactive({
      list: [],
      selected: [],
      showDialog: false,
      onSave: step2OnSave,
      owners: [
        { id: "P", name: "Propietario" },
        { id: "I", name: "Inquilino" },
      ],
      data: {
        id: "",
        tower: "",
        apartment: "",
        owner: "",
        prevBalance: "",
        payments: "",
        balance: "",
        surcharge: "",
        commonExpenses: "",
        extraFee: "",
        reserveFound: "",
        commonAreas: "",
        totalPeriod: "",
        totalDebt: "",
      },
      rules: {
        tower: false,
        apartment: false,
        owner: false,
        prevBalance: false,
        payments: false,
        balance: false,
        surcharge: false,
        commonExpenses: false,
        extraFee: false,
        reserveFound: false,
        commonAreas: false,
        totalPeriod: false,
        totalDebt: false,
      },
      schema: {
        "No. torre": {
          prop: "tower",
          type: String,
        },
        "No. apto": {
          prop: "apartment",
          type: String,
        },
        "Propietario o Inquilino (P o I)": {
          prop: "owner",
          type: String,
        },
        "Saldo mes anterior": {
          prop: "prevBalance",
          type: Number,
        },
        Pagos: {
          prop: "payments",
          type: Number,
        },
        "Saldo mes actual": {
          prop: "balance",
          type: Number,
        },
        "Recargo o deuda": {
          prop: "surcharge",
          type: Number,
        },
        "Gastos comunes": {
          prop: "commonExpenses",
          type: Number,
        },
        "Cuota extra": {
          prop: "extraFee",
          type: Number,
        },
        "Fondo reserva": {
          prop: "reserveFound",
          type: Number,
        },
        "Áreas comunes": {
          prop: "commonAreas",
          type: Number,
        },
        "Total del período": {
          prop: "totalPeriod",
          type: Number,
        },
        "Total a pagar del mes": {
          prop: "totalDebt",
          type: Number,
        },
      },
      columns: [
        {
          field: "tower",
          header: "No. torre",
          sort: true,
        },
        {
          field: "apartment",
          header: "No. apto",
          sort: true,
        },
        {
          field: "owner",
          header: "Propietario o Inquilino (P o I)",
          sort: true,
        },
        {
          field: "prevBalance",
          header: "Saldo mes anterior",
          sort: true,
          currency: true,
        },
        {
          field: "payments",
          header: "Pagos",
          sort: true,
          currency: true,
        },
        {
          field: "balance",
          header: "Saldo mes actual",
          sort: true,
          currency: true,
        },
        {
          field: "surcharge",
          header: "Recargo o deuda",
          sort: true,
          currency: true,
        },
        {
          field: "commonExpenses",
          header: "Gastos comunes",
          sort: true,
          currency: true,
        },
        {
          field: "extraFee",
          header: "Cuota extra",
          sort: true,
          currency: true,
        },
        {
          field: "reserveFound",
          header: "Fondo reserva",
          sort: true,
          currency: true,
        },
        {
          field: "commonAreas",
          header: "Áreas comunes",
          sort: true,
          currency: true,
        },
        {
          field: "totalPeriod",
          header: "Total del período",
          sort: true,
          currency: true,
        },
        {
          field: "totalDebt",
          header: "Total a pagar del mes",
          sort: true,
          currency: true,
        },
      ],
      actions: [
        {
          name: "Modificar",
          action: () => {
            if (step2.selected.length !== 1) {
              alert("Debe seleccionar un registro!");
            } else {
              step2.data.id = step2.selected[0].id;
              step2.data.tower = step2.selected[0].tower;
              step2.data.apartment = step2.selected[0].apartment;
              step2.data.prevBalance = step2.selected[0].prevBalance;
              step2.data.payments = step2.selected[0].payments;
              step2.data.balance = step2.selected[0].balance;
              step2.data.surcharge = step2.selected[0].surcharge;
              step2.data.commonExpenses = step2.selected[0].commonExpenses;
              step2.data.extraFee = step2.selected[0].extraFee;
              step2.data.reserveFound = step2.selected[0].reserveFound;
              step2.data.commonAreas = step2.selected[0].commonAreas;
              step2.data.totalPeriod = step2.selected[0].totalPeriod;
              step2.data.totalDebt = step2.selected[0].totalDebt;
              step2.showDialog = true;
            }
          },
          hidden: true,
        },
        {
          name: "Descargar Plantilla",
          action: async () => {
            await store.commit("setLoading", true);
            await store.dispatch(actions.commonExpenseActions.templateDetail);
            await store.commit("setLoading", false);
          },
          hidden: true,
        },
        {
          name: "Importar Datos",
          action: () => {
            const input = document.getElementById("upload-detail");
            input.addEventListener("change", onChangeDetail, true);
            input.click();
          },
          hidden: true,
        },
      ],
    });

    const step3 = reactive({
      list: [],
      selected: [],
      showDialog: false,
      onSave: step3OnSave,
      negative: false,
      negative1: false,
      data: {
        id: "",
        heading: "",
        detail: "",
        date: "",
        income: "",
        expense: "",
        total: "",
      },
      rules: {
        id: false,
        heading: false,
        date: false,
        income: false,
        expense: false,
        total: false,
      },
      schema: {
        Rubro: {
          prop: "heading",
          type: String,
        },
        Detalle: {
          prop: "detail",
          type: String,
        },
        Fecha: {
          prop: "date",
          type: String,
        },
        Ingreso: {
          prop: "income",
          type: Number,
        },
        Egreso: {
          prop: "expense",
          type: Number,
        },
        Total: {
          prop: "total",
          type: Number,
        },
      },
      columns: [
        {
          field: "heading",
          header: "Rubro",
          sort: true,
        },
        {
          field: "detail",
          header: "Detalle",
          sort: true,
        },
        {
          field: "date",
          header: "Fecha",
          sort: true,
          date: true,
        },
        {
          field: "income",
          header: "Ingreso",
          sort: true,
          currency: true,
        },
        {
          field: "expense",
          header: "Egreso",
          sort: true,
          currency: true,
        },
        {
          field: "total",
          header: "Total",
          sort: true,
          currency: true,
        },
      ],
      actions: [
        {
          name: "Modificar",
          action: () => {
            if (step3.selected.length !== 1) {
              alert("Debe seleccionar un registro!");
            } else {
              step3.data.id = step3.selected[0].id;
              step3.data.heading = step3.selected[0].heading;
              step3.data.detail = step3.selected[0].detail;
              step3.data.date = new Date(step3.selected[0].date);
              step3.data.income = step3.selected[0].income;
              step3.data.expense = step3.selected[0].expense;
              step3.data.total = step3.selected[0].total;
              step3.showDialog = true;
            }
          },
          hidden: true,
        },
        {
          name: "Descargar Plantilla",
          action: async () => {
            await store.commit("setLoading", true);
            await store.dispatch(actions.commonExpenseActions.templateMovement);
            await store.commit("setLoading", false);
          },
          hidden: true,
        },
        {
          name: "Importar Datos",
          action: () => {
            const input = document.getElementById("upload-movement");
            input.addEventListener("change", onChangeMovement, true);
            input.click();
          },
          hidden: true,
        },
      ],
    });

    const step4 = reactive({
      selectedDocuments: [],
      starting: false,
      checking: false,
      uploading: false,
      uploadedAttachments: 0,
      attachmentTotal: 0,
      pendingAttachmentNames: [],
      missingAttachments: false,
      generation: null,
      connectionError: "",
      error: "",
      documentsList: [
        {
          id: 0,
          status: true,
          title: "Documento de Gastos comunes por apartamento",
        },
        {
          id: 1,
          status: true,
          title: "Documento de Detalle de movimientos del complejo",
        },
      ],
    });
    const step5 = reactive({
      sendEnabled: false,
      sending: false,
      sendUncertain: false,
    });

    const generationBusy = computed(() =>
      step4.starting || step4.checking || step4.uploading || step4.generation?.status === "running"
    );
    const generateButtonLabel = computed(() => {
      if (step4.uploading) return "Subiendo adjuntos…";
      if (generationBusy.value) return "Generando…";
      if (step4.generation?.status === "completed" && step4.selectedDocuments.length) return "Subir adjuntos";
      return ["failed", "interrupted"].includes(step4.generation?.status) ? "Reintentar generación" : "Generar";
    });
    const attachmentsKey = () => `closure-attachments:${closureBuildingId.value}:${step1.data.id}`;
    const generationKey = () => `closure-generation:${closureBuildingId.value}:${step1.data.id}`;
    const syncRememberedGeneration = () => {
      try {
        if (step4.generation?.status === "running") {
          sessionStorage.setItem(generationKey(), step4.generation.jobId || "running");
        } else if (!step4.generation && closureStatusId.value < 4 && sessionStorage.getItem(generationKey())) {
          step4.generation = {
            status: "interrupted", phase: "failed", completed: 0, total: 0,
            error: "Se perdió el seguimiento de la generación. Consultá el estado y volvé a intentarlo.",
          };
        } else if (closureStatusId.value >= 4 || ["completed", "failed"].includes(step4.generation?.status)) {
          sessionStorage.removeItem(generationKey());
        }
      } catch (error) {
        console.warn("No se pudo recuperar el seguimiento de la generación", error);
      }
    };
    const savePendingAttachments = () => {
      try {
        if (step4.pendingAttachmentNames.length) {
          sessionStorage.setItem(attachmentsKey(), JSON.stringify(step4.pendingAttachmentNames));
        } else {
          sessionStorage.removeItem(attachmentsKey());
        }
      } catch (error) {
        console.warn("No se pudo guardar el estado de los adjuntos", error);
      }
    };
    const updateSendAvailability = () => {
      step5.sendEnabled = closureStatusId.value === 4 &&
        (!step4.generation || step4.generation.status === "completed") &&
        !generationBusy.value && !step4.selectedDocuments.length && !step4.pendingAttachmentNames.length && !step4.error && !step5.sendUncertain;
    };
    const invalidateGeneratedDocuments = (statusId) => {
      closureStatusId.value = statusId;
      step4.generation = null;
      step4.error = "";
      updateSendAvailability();
    };
    const onSelectFiles = (ev) => {
      step4.selectedDocuments = ev.files || [];
      step4.missingAttachments = step4.pendingAttachmentNames.some(
        (name) => !step4.selectedDocuments.some((file) => file.name === name)
      );
      updateSendAvailability();
    };
    const onClearFiles = () => {
      step4.selectedDocuments = [];
      step4.pendingAttachmentNames = [];
      step4.missingAttachments = false;
      step4.error = "";
      savePendingAttachments();
      updateSendAvailability();
    };

    const applyClosureProgress = (closure) => {
      if (!closureInitialized) {
        const period = new Date(closure.period);
        step1.data.actualBalance = closure.actualBalance;
        step1.data.month = period.getMonth();
        step1.data.year = period.getFullYear();
        step1.data.expirationDate = new Date(closure.expirationDate);
        step1.data.comment = closure.comment;
        if (Number(closure.statusId) >= 5) hidden.value = true;
        lastStep.value = hidden.value ? Math.min(3, Number(closure.statusId)) : Math.min(5, Number(closure.statusId) + 1);
        stepSelected.value = hidden.value ? 1 : lastStep.value;
        closureInitialized = true;
      }
      closureStatusId.value = Number(closure.statusId);
      step4.generation = closure.documentGeneration || null;
      syncRememberedGeneration();
      step4.connectionError = "";
      step4.checking = false;
      store.commit("setSelectedClosures", [closure]);
      updateSendAvailability();
      if (["failed", "interrupted"].includes(step4.generation?.status)) {
        lastStep.value = 4;
        if (!hidden.value) stepSelected.value = 4;
      } else if (step4.generation?.status === "running") {
        step4.error = "";
        lastStep.value = 4;
        if (!hidden.value) stepSelected.value = 4;
      } else if (closureStatusId.value === 4 && (!step4.generation || step4.generation.status === "completed") && !hidden.value) {
        lastStep.value = 5;
        if (step4.pendingAttachmentNames.length) {
          if (!step4.missingAttachments && !step4.uploading && !step4.error) {
            uploadAdditionalDocuments();
          }
        } else if (stepSelected.value === 4) {
          stepSelected.value = 5;
        }
      }
    };
    const poller = createClosurePoller({
      load: () => store.dispatch(actions.commonExpenseActions.findAllClosure, {
        buildingId: closureBuildingId.value,
        silent: true,
        updateStore: false,
      }),
      onData: (response) => {
        const closure = response.closures.find((item) => Number(item.id) === Number(step1.data.id));
        if (!closure) {
          step4.checking = false;
          step4.error = "No se encontró el cierre. Volvé al listado para actualizarlo.";
          step5.sendEnabled = false;
          return false;
        }
        applyClosureProgress(closure);
        return step4.generation?.status === "running";
      },
      onError: (response, retrying) => {
        step4.checking = true;
        step5.sendEnabled = false;
        step4.connectionError = retrying
          ? "No se pudo actualizar el avance. Reintentando la conexión automáticamente; el último avance conocido se mantiene."
          : response?.message || "No se pudo consultar el estado. Actualizá la página para volver a intentar.";
      },
    });
    const startPolling = () => {
      if (!mounted || step1.data.id <= 0) return;
      step4.checking = true;
      step5.sendEnabled = false;
      return poller.start();
    };
    const refreshStatus = () => {
      step5.sendUncertain = false;
      return startPolling();
    };

    const onChangeDetail = () => {
      const input = document.getElementById("upload-detail");
      readXlsxFile(input.files[0], { schema: step2.schema }).then(
        ({ rows, errors }) => {
          if (!rows.length || errors.length)
            store.state.toast.add({
              severity: "error",
              summary: "",
              detail: "Error al importar los datos",
              life: 5000,
            });
          step2.list = [];
          processFile(rows, step2.list, step2.columns);
        }
      );
    };
    const onChangeMovement = () => {
      const input = document.getElementById("upload-movement");
      readXlsxFile(input.files[0], {
        schema: step3.schema,
      }).then(({ rows, errors }) => {
        if (!rows.length || errors.length)
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: "Error al importar los datos",
            life: 5000,
          });
        step3.list = [];
        processFile(rows, step3.list, step3.columns);
      });
    };

    const getActualBalance = (list) => {
      let balance = +step1.data.actualBalance;
      if (!list) {
        if (balance < 0) step3.negative1 = true;
        else step3.negative1 = false;
      } else {
        if (list.length) list.forEach((item) => (balance += item.total));
        if (balance < 0) step3.negative = true;
        else step3.negative = false;
      }

      return currency.convertNumberToCurrency(balance);
    };

    const onNext = async () => {
      if (generationBusy.value || step5.sending) return;
      switch (stepSelected.value) {
        case 1:
          await executeStep1();
          break;
        case 2:
          await executeStep2();
          break;
        case 3:
          await executeStep3();
          break;
        case 4:
          await executeStep4();
          break;
        default:
          break;
      }
    };

    const processFile = (rows, list, columns) => {
      for (let i = 0; i < rows.length; i++) {
        rows[i].id = (i + 1) * -1;
        columns.forEach((el) => {
          if (el.date) {
            rows[i][el.field] = dates.convertStringToDate(rows[i][el.field]);
          }
        });
        list.push(rows[i]);
      }
      if (stepSelected.value === 2) {
        const input = document.getElementById("upload-detail");
        input.removeEventListener("change", onChangeDetail, true);
      } else if (stepSelected.value === 3) {
        const input = document.getElementById("upload-movement");
        input.removeEventListener("change", onChangeMovement, true);
      }
    };

    const executeStep1 = async () => {
      if (!validateStep1()) return;

      store.commit("setLoading", true);
      const tempDate = new Date();
      tempDate.setMonth(step1.data.month);
      tempDate.setFullYear(step1.data.year);
      tempDate.setHours(0, 0, 0, 0);

      const request = {
        buildingId: store.state.general.selectedBuilding,
        id: step1.data.id,
        period: new Date(tempDate).getTime(),
        expirationDate: new Date(step1.data.expirationDate).getTime(),
        comment: step1.data.comment,
        commonExpenseStatusId: 1,
        actualBalance: +step1.data.actualBalance,
      };
      const response = await store.dispatch(
        actions.commonExpenseActions.create,
        request
      );
      if (response.ok) {
        step1.data.id = response.commonExpenseId;
        invalidateGeneratedDocuments(1);
        stepSelected.value = stepSelected.value + 1;
        if (lastStep.value < stepSelected.value) {
          lastStep.value = lastStep.value + 1;
        }
        const detail = await store.dispatch(
          actions.commonExpenseActions.findAllDetail,
          step1.data.id
        );
        store.commit("setLoading", false);
        if (detail.ok) {
          step2.list = detail.commonExpensesDetail;
        } else {
          store.commit("setLoading", false);
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: detail.message,
            life: 5000,
          });
        }
      } else {
        store.commit("setLoading", false);
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: response.message,
          life: 5000,
        });
      }
    };

    const executeStep2 = async () => {
      if (!validateStep2(true)) return;

      store.commit("setLoading", true);
      const request = {
        buildingId: store.state.general.selectedBuilding,
        commonExpenseId: step1.data.id,
        data: step2.list.map((item) => ({
          id: item.id,
          tower: item.tower,
          apartment: item.apartment,
          owner: item.owner,
          prevBalance: item.prevBalance,
          prevPayment: item.payments,
          balance: item.balance,
          surcharge: item.surcharge,
          commonExpenses: item.commonExpenses,
          extraFee: item.extraFee,
          reserveFound: item.reserveFound,
          commonAreas: item.commonAreas,
          totalPeriod: item.totalPeriod,
          totalDebt: item.totalDebt,
        })),
      };
      const response = await store.dispatch(
        actions.commonExpenseActions.createDetail,
        request
      );
      store.commit("setLoading", false);
      if (response.ok) {
        invalidateGeneratedDocuments(2);
        stepSelected.value = stepSelected.value + 1;
        if (lastStep.value < stepSelected.value) {
          lastStep.value = lastStep.value + 1;
        }
      } else {
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: response.message,
          life: 5000,
        });
      }
      store.commit("setLoading", true);
      const movement = await store.dispatch(
        actions.commonExpenseActions.findAllMovement,
        step1.data.id
      );
      store.commit("setLoading", false);
      if (movement.ok) {
        step3.list = movement.movements;
      } else {
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: movement.message,
          life: 5000,
        });
      }
    };

    const executeStep3 = async () => {
      if (!validateStep3(true)) return;

      store.commit("setLoading", true);
      const request = {
        buildingId: store.state.general.selectedBuilding,
        commonExpenseId: step1.data.id,
        data: step3.list.map((item) => ({
          id: item.id,
          heading: item.heading,
          detail: item.detail,
          date: new Date(item.date).getTime(),
          charge: item.income,
          debt: item.expense,
          total: item.total,
        })),
      };
      const response = await store.dispatch(
        actions.commonExpenseActions.createMovement,
        request
      );
      store.commit("setLoading", false);
      if (response.ok) {
        invalidateGeneratedDocuments(3);
        stepSelected.value = stepSelected.value + 1;
        if (lastStep.value < stepSelected.value) {
          lastStep.value = lastStep.value + 1;
        }
      } else {
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: response.message,
          life: 5000,
        });
      }
    };

    const uploadAdditionalDocuments = async () => {
      if (step4.uploading || step4.missingAttachments || !mounted) return;
      step4.uploading = true;
      step4.error = "";
      step5.sendEnabled = false;
      stepSelected.value = 4;
      step4.uploadedAttachments = 0;
      const files = [...step4.selectedDocuments];
      step4.attachmentTotal = files.length;
      try {
        const building = store.state.auth.user.buildings.find(
          (item) => Number(item.id) === Number(closureBuildingId.value)
        );
        if (!building) throw new Error("No se encontró el edificio para guardar los adjuntos.");
        const response = await store.dispatch("GENERAL_GET_SIGNED_URL", {
          buildingId: closureBuildingId.value,
          commonExpenseId: step1.data.id,
        });
        if (!response.ok) throw new Error(response.message || "No se pudo preparar la carga de adjuntos.");
        for (const doc of files) {
          if (!mounted) return;
          const name = `${building.name}-${doc.name}`;
          const extension = validation.extensionRegex.exec(name);
          if (!extension) throw new Error(`El adjunto ${doc.name} no tiene una extensión válida.`);
          await new Promise((resolve, reject) => {
            aws.uploadFile(`${response.path}${name}`, doc, (result, error) => {
              if (error || result?.ok === false) reject(error || new Error(result.message));
              else resolve(result);
            });
          });
          const saved = await store.dispatch(actions.commonExpenseActions.saveDocument, {
            path: response.path,
            name: name.split(".").slice(0, -1).join("."),
            ext: extension[0],
            buildingId: building.id,
            entityId: step1.data.id,
          });
          if (!saved.ok) throw new Error(saved.message || `No se pudo registrar ${doc.name}.`);
          step4.uploadedAttachments += 1;
          step4.selectedDocuments = step4.selectedDocuments.filter((file) => file !== doc);
          const pendingIndex = step4.pendingAttachmentNames.indexOf(doc.name);
          if (pendingIndex >= 0) step4.pendingAttachmentNames.splice(pendingIndex, 1);
          savePendingAttachments();
        }
        if (mounted) stepSelected.value = 5;
      } catch (error) {
        step4.error = `Falló la carga de un adjunto: ${error.message || "error de conexión"}. Podés reintentar la carga.`;
      } finally {
        step4.uploading = false;
        updateSendAvailability();
      }
    };

    const executeStep4 = async () => {
      if (generationBusy.value || step5.sending || step4.missingAttachments) return;
      if (closureStatusId.value === 4 && step4.selectedDocuments.length) {
        step4.pendingAttachmentNames = step4.selectedDocuments.map((file) => file.name);
        savePendingAttachments();
        await uploadAdditionalDocuments();
        return;
      }
      step5.sendEnabled = false;
      step4.starting = true;
      step4.error = "";
      step4.connectionError = "";
      step4.pendingAttachmentNames = step4.selectedDocuments.map((file) => file.name);
      savePendingAttachments();
      try {
        const request = {
          buildingId: closureBuildingId.value,
          commonExpenseId: step1.data.id,
        };
        const response = await store.dispatch(
          actions.commonExpenseActions.generate,
          request
        );
        if (response.ok) {
          step4.generation = response.documentGeneration || { status: "running", phase: "queued", completed: 0, total: 0 };
          syncRememberedGeneration();
          if (!mounted) return;
          await router.replace({ path: route.path, query: { ...route.query, cierre: step1.data.id, edificio: closureBuildingId.value } });
          if (mounted) startPolling();
        } else {
          step4.error = response.message || "No se pudo iniciar la generación de documentos.";
          // A lost HTTP response does not prove that the server failed to start.
          if (mounted) startPolling();
        }
      } catch (error) {
        step4.error = error.message || "No se pudo iniciar la generación de documentos.";
        if (mounted) startPolling();
      } finally {
        step4.starting = false;
        updateSendAvailability();
      }
    };

    const onSend = async () => {
      if (!step5.sendEnabled || generationBusy.value || step5.sending) return;
      step5.sending = true;
      try {
        const closureStatus = await store.dispatch(actions.commonExpenseActions.findAllClosure, {
          buildingId: closureBuildingId.value,
          silent: true,
        });
        if (!closureStatus.ok) throw new Error("No se pudo verificar el estado del cierre. Volvé a intentar cuando se restablezca la conexión.");
        const closure = closureStatus.closures.find(
          (item) => Number(item.id) === Number(step1.data.id)
        );
        if (!closure) throw new Error("No se encontró el cierre.");
        applyClosureProgress(closure);
        if (Number(closure.statusId) !== 4 || closure.documentGeneration?.status === "running" || !step5.sendEnabled) {
          step5.sendEnabled = false;
          startPolling();
          throw new Error("Los documentos todavía no están listos para enviar.");
        }
        const response = await store.dispatch(actions.commonExpenseActions.send, {
          buildingId: closureBuildingId.value,
          commonExpenseId: step1.data.id,
        });
        if (!mounted) return;
        if (response.ok) {
          store.state.toast.add({ severity: "success", summary: "", detail: response.message, life: 5000 });
          router.push("/cierres/listado");
          return;
        }
        if (response.deliveryUncertain) {
          step5.sendUncertain = true;
          step5.sendEnabled = false;
          const refreshed = await store.dispatch(actions.commonExpenseActions.findAllClosure, {
            buildingId: closureBuildingId.value,
            silent: true,
            updateStore: false,
          });
          if (!mounted) return;
          const current = refreshed.ok && refreshed.closures.find((item) => Number(item.id) === Number(step1.data.id));
          if (current) applyClosureProgress(current);
          if (current && Number(current.statusId) >= 5) {
            step5.sendUncertain = false;
            store.state.toast.add({ severity: "success", summary: "", detail: "El cierre figura como enviado.", life: 5000 });
            router.push("/cierres/listado");
          } else {
            store.state.toast.add({
              severity: "warn", summary: "",
              detail: "No se pudo confirmar el resultado del envío. Actualizá el estado del cierre antes de volver a enviar para evitar duplicados.",
              life: 10000,
            });
          }
          return;
        }
        throw new Error(response.message || "No se pudo confirmar el envío de los correos.");
      } catch (error) {
        if (mounted) store.state.toast.add({ severity: "error", summary: "", detail: error.message, life: 7000 });
      } finally {
        step5.sending = false;
      }
    };

    onBeforeMount(() => {
      store.commit("addBreadcrumb", { label: route.name, to: route.path });
    });

    onMounted(async () => {
      const selected = store.state.commonExpense.selectedClosures[0];
      const requestedId = Number(route.query.cierre) || selected?.id;
      if (requestedId && (route.query.cierre || store.state.openMode !== openMode.CREATE)) {
        const mode = route.query.vista === "detalle" ? openMode.DETAIL : store.state.openMode || openMode.MODIFY;
        store.commit("setOpenMode", mode);
        hidden.value = mode === openMode.DETAIL;
        step1.data.id = requestedId;
        const building = store.state.auth.user.buildings.find(
          (item) => Number(item.id) === Number(closureBuildingId.value)
        );
        if (!building) {
          router.replace("/cierres/listado");
          return;
        }
        store.commit("setGeneralSelectedBuilding", building.id);
        try {
          const pendingNames = JSON.parse(sessionStorage.getItem(attachmentsKey()) || "[]");
          step4.pendingAttachmentNames = Array.isArray(pendingNames) ? pendingNames : [];
          step4.missingAttachments = step4.pendingAttachmentNames.length > 0;
        } catch (error) {
          console.warn("No se pudo recuperar el estado de los adjuntos", error);
        }
        step4.checking = true;
        store.commit("setLoading", true);
        const response = await store.dispatch(actions.commonExpenseActions.findAllClosure, {
          buildingId: closureBuildingId.value,
          silent: true,
        });
        store.commit("setLoading", false);
        if (!mounted) return;
        const current = response.ok && response.closures.find((item) => Number(item.id) === Number(requestedId));
        if (!current) {
          step4.connectionError = response.message || "No se pudo recuperar el cierre.";
          stepSelected.value = 4;
          lastStep.value = 4;
          startPolling();
          return;
        }
        const tempDate = new Date(current.period);
        step1.data.actualBalance = current.actualBalance;
        step1.data.month = tempDate.getMonth();
        step1.data.year = tempDate.getFullYear();
        step1.data.expirationDate = new Date(current.expirationDate);
        step1.data.comment = current.comment;
        if (Number(current.statusId) >= 5) hidden.value = true;
        lastStep.value = hidden.value ? Math.min(3, Number(current.statusId)) : Math.min(5, Number(current.statusId) + 1);
        stepSelected.value = hidden.value ? 1 : lastStep.value;
        applyClosureProgress(current);
        if (step4.missingAttachments && !hidden.value) stepSelected.value = 4;
        if (step4.generation?.status === "running") startPolling();
      } else if (!store.state.openMode) {
        router.replace("/cierres/listado");
        return;
      }
      if (store.state.openMode === openMode.MODIFY) {
        if (stepSelected.value === 2) {
          store.commit("setLoading", true);
          const detail = await store.dispatch(
            actions.commonExpenseActions.findAllDetail,
            step1.data.id
          );
          store.commit("setLoading", false);
          if (detail.ok) {
            step2.list = detail.commonExpensesDetail;
          } else {
            store.state.toast.add({
              severity: "error",
              summary: "",
              detail: detail.message,
              life: 5000,
            });
          }
        } else if (stepSelected.value === 3) {
          store.commit("setLoading", true);
          const movement = await store.dispatch(
            actions.commonExpenseActions.findAllMovement,
            step1.data.id
          );
          store.commit("setLoading", false);
          if (movement.ok) {
            step3.list = movement.movements;
          } else {
            store.state.toast.add({
              severity: "error",
              summary: "",
              detail: movement.message,
              life: 5000,
            });
          }
        }
      }
    });

    onBeforeUnmount(() => {
      mounted = false;
      poller.stop();
      store.commit("removeBreadcrumb");
    });

    watch(() => store.state.general.selectedBuilding, (buildingId) => {
      if (step1.data.id > 0 && Number(buildingId) !== Number(closureBuildingId.value)) {
        poller.stop();
        router.replace("/cierres/listado");
      } else if (step1.data.id <= 0) {
        closureBuildingId.value = buildingId;
      }
    });
    watch(() => route.query.cierre, (id, previousId) => {
      if (previousId && id && Number(id) !== Number(previousId)) {
        poller.stop();
        router.replace("/cierres/listado");
      }
    });
    watchEffect(() => {
      stepsDisabled.value = generationBusy.value || step5.sending ? [1, 2, 3, 5] : [];
    });

    watchEffect(() => {
      /** Step 1 */
      if (step1.data.actualBalance) step1.rules.actualBalance = false;
      if (step1.data.expirationDate) step1.rules.expirationDate = false;
      /** Step 2 */
      if (step2.data.tower) step2.rules.tower = false;
      if (step2.data.apartment) step2.rules.apartment = false;
      if (step2.data.owner) step2.rules.owner = false;
      if (step2.data.prevBalance || step2.data.prevBalance == 0)
        step2.rules.prevBalance = false;
      if (step2.data.payments || step2.data.payments == 0)
        step2.rules.payments = false;
      step2.data.balance =
        Number(step2.data.prevBalance) - Number(step2.data.payments);
      if (step2.data.balance || step2.data.balance == 0)
        step2.rules.balance = false;
      if (step2.data.surcharge || step2.data.surcharge == 0)
        step2.rules.surcharge = false;
      if (step2.data.commonExpenses || step2.data.commonExpenses == 0)
        step2.rules.commonExpenses = false;
      if (step2.data.extraFee || step2.data.extraFee == 0)
        step2.rules.extraFee = false;
      if (step2.data.reserveFound || step2.data.reserveFound == 0)
        step2.rules.reserveFound = false;
      if (step2.data.commonAreas || step2.data.commonAreas == 0)
        step2.rules.commonAreas = false;
      step2.data.totalPeriod =
        Number(step2.data.commonExpenses) +
        Number(step2.data.extraFee) +
        Number(step2.data.reserveFound) +
        Number(step2.data.commonAreas);
      if (step2.data.totalPeriod || step2.data.totalPeriod == 0)
        step2.rules.totalPeriod = false;
      step2.data.totalDebt =
        Number(step2.data.balance) +
        Number(step2.data.surcharge) +
        Number(step2.data.totalPeriod);
      if (step2.data.totalDebt || step2.data.totalDebt == 0)
        step2.rules.totalDebt = false;
      /** Step 3 */
      if (step3.data.heading) step3.rules.heading = false;
      if (step3.data.date) step3.rules.date = false;
      if (step3.data.income || step3.data.icome == 0)
        step3.rules.income = false;
      if (step3.data.expense || step3.data.expense == 0)
        step3.rules.expense = false;
      step3.data.total = Number(step3.data.income) - Number(step3.data.expense);
      if (step3.data.total) step3.rules.total = false;
    });

    return {
      steps,
      lastStep,
      stepSelected,
      stepsDisabled,
      onSelectStep,
      onNext,
      onSend,
      step1,
      step2,
      step3,
      step4,
      step5,
      store,
      getActualBalance,
      hidden,
      onSelectFiles,
      onClearFiles,
      generationBusy,
      generateButtonLabel,
      startPolling,
      refreshStatus,
    };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
}
.step3-container {
  display: flex;
  justify-content: space-around;
}
.upload {
  display: none;
}
.operation-progress, .operation-note, .operation-error {
  width: calc(100% - 2rem);
  max-width: 640px;
  margin: 1rem auto;
  color: var(--primary-dark);
  overflow-wrap: anywhere;
}
.operation-progress p { margin: 0.75rem 0; }
.operation-progress :deep(.p-progressbar) { height: 0.65rem; }
.operation-progress :deep(.p-progressbar-value) { background: var(--primary); }
.operation-error { color: var(--danger); }
</style>
